const inset = {
  state: {
    open: false
  },

  mutations: {
    setInsetOpen(state, open) {
      state.open = open;
    }
  },

  actions: {
    setInsetOpen({ commit }) {
      commit("setInsetOpen", true);
    },

    setInsetClosed({ commit }) {
      commit("setInsetOpen", false);
    }
  }
};

export default inset;
